import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { APP_CONFIG } from '../config';
import { GapiDAO } from './gapi.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { LogService } from '../services/logging.service';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { RateRuleDataValidator } from './validators/data.validators';
import { GuestAPI, IRateRuleParams, RoomGrouping } from '../interfaces/RateRuleParameters';

const CLASS_NAME = 'RateRuleDao';

@Injectable()
export class RateRuleDao extends GapiDAO {

  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService) {
    super(CLASS_NAME, http, appConfig, appConfig.rateRuleDAO, new DefaultRetryHandler(), new RateRuleDataValidator(), log);
  }

  get({
    hotelCode, rateCode, roomCode, adults, rooms, dateRange,
    children = 0, roomGrouping = RoomGrouping.NONE, showPointsRate = false, showEmployeeRate = false, version = GuestAPI.VERSION_1_3
  }: IRateRuleParams): Observable<any> {
    const payload = Object.assign({}, arguments[0], { children, roomGrouping, showPointsRate, showEmployeeRate, version });
    const url = this.daoConfig.url
      .replace('{country}', this.appConfig.country)
      .replace('{language}', this.appConfig.language);
    return super.doPost(url, payload);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/rate-rule.dao.ts